export default "__VITE_ASSET__Cw3ahRY1__"